/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IInspectorNode_Default, INSPECTOR_NODE_TYPE } from "./InspectorNodeTypes";

export function createDefaultNode(
	props: Partial<Omit<IInspectorNode_Default, "type">> = {}
): IInspectorNode_Default {
	return {
		type: INSPECTOR_NODE_TYPE.DEFAULT,
		key: "",
		label: "",
		tooltip: "",
		descriptor: null,
		referenceData: null,
		options: null,
		default: null,
		required: false,
		deps: [],
		controls: [],
		children: [],
		...props
	};
}
